import React from 'react';
import ApplicationsManagement from '../../components/company/ApplicationsManagement/ApplicationsManagement.jsx';

const Applications = () => {
  return (
    <div>
      <ApplicationsManagement />
    </div>
  );
};

export default Applications;